import { useCallback } from 'react'
import { CurrencyEnum, DEFAULT_CURRENCY } from '@vacationtracker/shared/common/currency'
import { LocaleEnum } from '@vacationtracker/shared/types/i18n'
import { formatCurrency } from '@vacationtracker/shared/functions/format-currency'
import { useAppSelector } from '../store/hooks'
import { selectAuthCompanySlice } from '../store/auth-company-slice'
import { selectLocaleSlice } from '../store/locale-slice'

interface UseCurrencyResult {
  currency: CurrencyEnum
  formatPrice: (amount: number) => string
}

export function useCurrency(): UseCurrencyResult {
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  const { locale } = useAppSelector(selectLocaleSlice)

  const currency = (authCompany?.billing?.defaultCurrency || DEFAULT_CURRENCY) as CurrencyEnum

  const localeEnum = (locale?.locale ?? 'en') as LocaleEnum

  const formatPrice = useCallback((amount: number) => formatCurrency({ amount, currency, locale: localeEnum }), [currency, localeEnum])

  return { currency, formatPrice }
}
